import { render, staticRenderFns } from "./StadiumChatRooms.vue?vue&type=template&id=7be8649a&"
import script from "./StadiumChatRooms.vue?vue&type=script&lang=js&"
export * from "./StadiumChatRooms.vue?vue&type=script&lang=js&"
import style0 from "./StadiumChatRooms.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be8649a')) {
      api.createRecord('7be8649a', component.options)
    } else {
      api.reload('7be8649a', component.options)
    }
    module.hot.accept("./StadiumChatRooms.vue?vue&type=template&id=7be8649a&", function () {
      api.rerender('7be8649a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumChatRooms.vue"
export default component.exports